import type { ComponentProps } from "react";

export default function LightBulbIcon(props: ComponentProps<"svg">) {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M13.9987 2.33325V3.49992M3.4987 13.9999H2.33203M6.41536 6.41659L5.71525 5.71647M21.582 6.41659L22.2823 5.71647M25.6654 13.9999H24.4987M11.6654 15.7499H16.332M13.9987 15.7499V21.5833M18.082 19.6862C19.8484 18.4155 20.9987 16.342 20.9987 13.9999C20.9987 10.1339 17.8647 6.99992 13.9987 6.99992C10.1327 6.99992 6.9987 10.1339 6.9987 13.9999C6.9987 16.342 8.14895 18.4155 9.91536 19.6862V21.9333C9.91536 23.24 9.91536 23.8934 10.1697 24.3926C10.3934 24.8316 10.7503 25.1886 11.1894 25.4123C11.6885 25.6666 12.3419 25.6666 13.6487 25.6666H14.3487C15.6555 25.6666 16.3089 25.6666 16.808 25.4123C17.2471 25.1886 17.604 24.8316 17.8277 24.3926C18.082 23.8934 18.082 23.24 18.082 21.9333V19.6862Z"
        stroke="current"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
